import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d18c377"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "m-breadcrumb" }
const _hoisted_2 = ["onClick"]

import { useRouter }  from 'vue-router';
    
export default /*#__PURE__*/_defineComponent({
  __name: 'IBreadcrumb',
  props: {
        data: {
            type: Array,
            default: () => ({} as {
                path: string;
                name: string;
            }),
        },
        agreement : {
            type: Boolean,
            default: false
        }
    },
  setup(__props) {

const props = __props;

    const router = useRouter()
    
    const targetTo = (path: string) => {
        if(path === '/agreement') {
            location.reload()
            return
        }
        if (path) {
            router.push(path)
        }
    }
    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data, (item, index) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: `breadcrumb-${item.path}-${index}`
      }, [
        index
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["u-breadcrumb-sperator", [__props.agreement && 'u-breadcrumb-sperator-agreement']])
            }, null, 2))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(["u-breadcrumb", index < __props.data.length - 1 ? 'enable' : '']),
          onClick: () => targetTo(item.path)
        }, _toDisplayString(item.name), 11, _hoisted_2)
      ], 64))
    }), 128))
  ]))
}
}

})